export enum QCFormEvent {
  ON_FORM_LOADED = 'FormEvent_OnFormLoaded',
  ON_FORM_PAUSE = 'FormEvent_OnFormPause',
  ON_FORM_VALIDATING = 'FormEvent_OnFormValidating',
  ON_ROW_ADDED = 'FormEvent_OnRowAdded',
  ON_ROW_DELETED = 'FormEvent_OnRowDeleted',
  ON_IMAGE_CLICK = 'FormEvent_OnImageClick',
}
